import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';

import type {
    AddCollaboratorsMutation,
    AddCollaboratorsMutationVariables,
} from 'generated/graphql';
import { AddCollaboratorsDocument } from 'generated/graphql';
import invariant from 'tiny-invariant';

export const ADD_BUILD_HUB_COLLABORATORS_API_ROUTE =
    '/remix-api/app/build-hub-collaborator-add';

const DEFAULT_FAILED_MESSAGE = 'Failed to invite BuildHub collaborators.';

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('buildHubId'), 'No BuildHub ID provided for invite.');
    invariant(
        data.getAll('emails[]').length > 0,
        'No Emails provided for invite.'
    );

    let variables: AddCollaboratorsMutationVariables = {
        BuildHubID: data.get('buildHubId') as string,
        Emails: data.getAll('emails[]') as string[],
    };

    const role = data.get('role');
    if (role) {
        variables.Role = role;
    }

    const message = data.get('message');
    if (message) {
        variables.Message = message;
    }

    const teamMemberId = data.get('teamMemberId');
    if (teamMemberId) {
        variables.TeamMemberID = parseInt(teamMemberId as string, 10);
    }

    try {
        const { data: result } = await context.client.mutate<
            AddCollaboratorsMutation,
            AddCollaboratorsMutationVariables
        >({
            mutation: AddCollaboratorsDocument,
            variables,
        });

        const validResult = result?.buildHubCollaboratorAdd;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
